import { useSubmit } from 'react-router';
import { InsurancePlan, InsurancePlanTier } from '../types';
import { useState } from 'react';

export const findPlanIdByTier = (
  insurancePlans?: InsurancePlan[],
  insuranceTier?: InsurancePlanTier
): string | undefined => {
  return insurancePlans?.find((plan) => plan.tier === insuranceTier)?.id?.toString();
};

/**
 * Hook to organize the logic for handling the selection of an insurance plan in the PDP.
 * @param insurancePlans insurance plans of vehicle
 * @param selectedInsuranceTier insurance tier of selected insurance plan
 * @param postSubmitDelegate delegate function to call after submit occurs to react-router
 * @returns
 */
export default function usePDPInsurancePlanSubmit(
  insurancePlans?: InsurancePlan[],
  selectedInsuranceTier?: InsurancePlanTier,
  postSubmitDelegate?: (event: string) => void
): {
  handleSelectInsurancePlan: (event: string) => void;
  selectedInsurancePlanId?: string;
} {
  const submit = useSubmit();

  const [selectedInsurancePlanId, setSelectedInsurancePlanId] = useState<
    string | undefined
  >(findPlanIdByTier(insurancePlans, selectedInsuranceTier));

  const handleSelectInsurancePlan = (event: string) => {
    const selectedInsuranceTier = insurancePlans?.find(
      (plan) => plan.id === parseInt(event)
    )?.tier;

    if (selectedInsuranceTier !== undefined) {
      submit(
        {
          intent: 'update_selected_insurance_tier',
          insurance_tier: selectedInsuranceTier,
        },
        {
          method: 'post',
        }
      );
      setSelectedInsurancePlanId(event);
      postSubmitDelegate?.(event);
    }
  };

  return { handleSelectInsurancePlan, selectedInsurancePlanId };
}
